/**
 * Calculate the final price after applying discount
 * @param {number} salesPrice - Original sales price
 * @param {number} salesDiscount - Discount amount
 * @returns {number} Final price after discount
 */
export const calculateFinalPrice = (salesPrice, salesDiscount = 0) => {
  const price = parseFloat(salesPrice) || 0;
  const discount = parseFloat(salesDiscount) || 0;
  return Math.max(0, price - discount);
};

/**
 * Calculate the total price for a cart item (final price * quantity)
 * @param {Object} item - Cart item with sales_price, sales_discount, and quantity
 * @returns {number} Total price for the item
 */
export const calculateItemTotal = (item) => {
  const finalPrice = calculateFinalPrice(item.sales_price, item.sales_discount);
  const quantity = parseInt(item.quantity) || 1;
  return finalPrice * quantity;
};

/**
 * Calculate the total price for all cart items
 * @param {Array} cartItems - Array of cart items
 * @returns {number} Total price for all items
 */
export const calculateCartTotal = (cartItems) => {
  return cartItems.reduce((total, item) => {
    return total + calculateItemTotal(item);
  }, 0);
}; 